const ViewBill = () => {
    return (
        <div className="flex justify-center items-center h-screen">
            Thank You for making a purchase with{' '}
            {process.env.REACT_APP_DEFAULT_MEDIA_LIBRARY_FOLDER}
        </div>
    );
};

export default ViewBill;
